import { DropdownList } from '@cpm-pr1618001/ng-design-lib';
import { Action, createFeature, createReducer, on } from '@ngrx/store';
import * as actions from '../actions/user-management.actions';
import {
  AccountNotification,
  ContactNotification,
  initialUserManagementState,
  UserManagementState,
} from '../state/user-management.state';

export const userManagementFeatureStoreKey: string = 'userManagement';

export const reducers = (
  state: UserManagementState,
  action: Action,
): UserManagementState => {
  return userManagementReducer(state, action);
};

export const userManagementReducer = createReducer(
  initialUserManagementState,
  on(actions.addProfileInfoToDropDownList, (state, { dropDownOption }) => {
    const updatedDropdownList = state.userDropdownList.map(
      (option: DropdownList) =>
        option.id === dropDownOption.id
          ? {
              ...option,
              label: dropDownOption.label,
              subLabel: dropDownOption.subLabel,
            }
          : option,
    );
    return {
      ...state,
      userDropdownList: updatedDropdownList,
    };
  }),
  on(actions.selectedMenuDropdownOption, (state, { selectedOption }) => {
    const updatedDropdownList = state.userDropdownList.map(
      (option: DropdownList) =>
        option.id === selectedOption.id
          ? { ...option, isSelected: true }
          : { ...option, isSelected: false },
    );
    return {
      ...state,
      userDropdownList: updatedDropdownList,
      selectedProfileOption: selectedOption,
    };
  }),
  on(actions.getNotifications, (state) => ({
    ...state,
    isNotificationsLoading: true,
  })),
  on(actions.getNotificationsSuccess, (state, { notifications, reload }) => ({
    ...state,
    notifications: reload
      ? notifications
      : concatNotifications(state.notifications, notifications),
    isNotificationsLoading: false,
  })),
  on(actions.getNotificationsError, (state) => ({
    ...state,
    isNotificationsLoading: false,
  })),
  on(actions.logOutUser, (state) => ({
    ...state,
    isSignOutError: false,
  })),
  on(actions.logOutUserSuccess, (state, { loggedOut }) => ({
    ...state,
    loggedOut,
    isSignOutError: false,
  })),
  on(actions.logOutUserError, (state) => ({
    ...state,
    isSignOutError: true,
  })),
  on(actions.getContacts, (state) => ({
    ...state,
    isContactLoading: true,
  })),
  on(actions.getContactsSuccess, (state, { contacts }) => ({
    ...state,
    contacts,
    isContactLoading: false,
  })),
  on(actions.getContactsError, (state) => ({
    ...state,
    isContactLoading: false,
  })),
);

export const userManagementFeature = createFeature({
  name: userManagementFeatureStoreKey,
  reducer: reducers,
});

export const concatNotifications = (
  currentNotifications: AccountNotification,
  newNotifications: AccountNotification,
): AccountNotification => {
  const currNotifications: ContactNotification[] =
    currentNotifications?.contacts || [];
  const newNotification: ContactNotification[] =
    newNotifications?.contacts || [];

  return { contacts: [...currNotifications, ...newNotification] };
};
